const sizeTokens = {
    "squircle.size.large": 72,
    "squircle.size.regular": 40
  },
  radiusTokens = {
    "squircle.radius": 12
  };
export { radiusTokens, sizeTokens };
//# sourceMappingURL=Squircle.tokens.mjs.map
